__turbopack_context__.v({
  "container": "NavigationControl-module__HbGQWa__container",
  "icon": "NavigationControl-module__HbGQWa__icon",
});
